import { useMemo } from "react"

import { getYear } from "date-fns"

import { Collapse, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { FILTERS } from "../../constants/filters"
import {
    TechniquesFiltersFormError,
    TechniquesFiltersFormPost,
    TechniquesFiltersFormSkeleton,
} from "../../forms/TechniquesFiltersForm"
import { useGetProjectTechniqueCodes } from "../../hooks/queries/useGetProjectTechniqueCodes"
import { useRoadworksProject } from "../../hooks/queries/useRoadworksProjectQuery"

export function TechniquesFilters(props: TechniquesFiltersProps) {

    const {
        className,
        close,
        displayFilters,
        enabledFilters = FILTERS,
    } = props

    const { data: project, isLoading: isLoadingProject, isError: isErrorProject } = useRoadworksProject()
    const { data: techniqueCodes, isLoading: isLoadingTechniques, isError: isErrorTechniques } = useGetProjectTechniqueCodes()
    const isMobile = useIsMobileDevice()

    const displayedYears = useMemo(() => {
        if (project) {
            const nowYear = getYear(Date.now())
            const roadworksYears = [...project.roadworksYears]
            const years = roadworksYears?.includes(nowYear) ? roadworksYears
                : roadworksYears.concat(nowYear).sort()
            return years
        }
        return null
    }, [project])

    const techniquesFiltersContent = useMemo(() => {
        if (isErrorProject || isErrorTechniques) {
            return <TechniquesFiltersFormError />
        } else if (isLoadingProject || isLoadingTechniques) {
            return <TechniquesFiltersFormSkeleton />
        }
        return <TechniquesFiltersFormPost enabledFilters={enabledFilters} close={close} years={displayedYears} techniques={techniqueCodes} />
    }, [close, displayedYears, enabledFilters, techniqueCodes, isErrorProject, isLoadingProject, isLoadingTechniques, isErrorTechniques])

    if (isMobile) {
        return techniquesFiltersContent
    } else {
        return <div className={className} >
            <Collapse in={displayFilters}>
                {techniquesFiltersContent}
            </Collapse>
        </div>
    }
}

type TechniquesFiltersProps = {
    className?: string
    enabledFilters?: Array<typeof FILTERS[number]>
    close: () => void
    displayFilters: boolean
}